import { Component } from 'react';
import { captureRenderError } from 'services/activity';

class ActivityErrorBoundary extends Component {
    state = { hasError: false };

    static getDerivedStateFromError() {
        return { hasError: true };
    }

    componentDidCatch(error, info) {
        captureRenderError(error, info?.componentStack);
    }

    render() {
        if (this.state.hasError) {
            return (
                <div role='alert' style={{ padding: 24 }}>
                    Something went wrong. Please refresh the page. If the problem continues, contact support.
                </div>
            );
        }

        return this.props.children;
    }
}

export default ActivityErrorBoundary;
